<template>
  <SSection
    :desktop-full="true"
    :title="t('views.cottage.reviews.title')"
    class="cottage-section-reviews"
  >
    <div
      v-if="reviews.items.length > 0"
      class="inline-flex items-center mb-4 cottage-section-reviews-average"
    >
      <TText>{{ t('views.cottage.reviews.averageRate') }}</TText>
      <TStars :stars="props.item.review.averageReviews" class="mb-4 ml-1" />
      <TText class="ml-2" color="text-gray-600"
        >({{ props.item.review.totalReviews }})</TText
      >
    </div>
    <SReviews
      v-if="reviews.items.length > 0"
      v-bind="reviews"
      variant="no-link"
      class="mb-4"
    />
    <div class="flex flex-col mt-3 gap-y-3 gap-x-5 lg:flex-row">
      <UButton
        v-if="reviews.items.length > 0"
        :ui="mobileFullWidthButton"
        color="primary"
        variant="solid"
        size="sm"
        type="button"
        :no-rel="true"
        :to="
          routes().allCottageReviews({
            slug: item.slug,
            province: item.province.slug,
          })
        "
        external
      >
        {{ t('views.cottage.reviews.seeAllReviews') }}
      </UButton>
      <UButton
        :ui="mobileFullWidthButton"
        variant="subtle"
        color="neutral"
        size="sm"
        type="button"
        :no-rel="true"
        @click="rateReview"
      >
        {{ t('views.cottage.reviews.rateCottage') }}
      </UButton>
    </div>
  </SSection>
</template>

<script setup lang="ts">
import type { CottagePage } from '../../entities/CottagePage'
import { useToSReviews } from '~/composables/transformers/useToSReviews'
import { mobileFullWidthButton } from '~~/modules/design-system/utils/nuxt-ui-config/components/button'

type itemType = Pick<CottagePage, 'reviews' | 'slug' | 'province' | 'review'>

interface propsInterface {
  item: itemType
}

let reviews: any = null

const props = defineProps<propsInterface>()

if (props.item.reviews) {
  reviews = useToSReviews().fromRuralityCottageReviewsDetail({
    dataIn: props.item.reviews,
  })
}

const rateReview = () => {
  navigateTo(
    routes().cottageReviewRate({
      slug: props.item.slug,
      province: props.item.province.slug,
    }),
    { external: true },
  )
}
</script>
